var weather = {
	data: {},
	url: "/assets/json/weather.json",
	init: function(){
		articleSpots = [];
		area.loadShop();
		load.getJson(weather.url, {}).done(function(json){
			weather.data = json;
			let HTML = '';
			for(var i = 0; i < json.length; i++){
				let d = weather.data[i];
				HTML += `<li><a href="javascript:void(0);" title="${d.name}" data-id="${i}"><p class="num">${d.no}</p><h5>${d.name}</h5><div class="desc"><p>${d.furigana}</p></div></a></li>`
			}
			$(".list_weather_inner ul").html(HTML);
			weather.nav();
		});
	},
	nav: function(){
		$(".list_weather_inner ul li a").off().on("click", function(){
			let idx = $(this).attr("data-id");
			let top = $(this).parent().position().top;
			let left = $(this).parent().position().left;
			weather.showDetail(idx, top, left);
		});
		$("a.btn_open").off("click").on("click", function(){
			$(this).remove();
			$(".list_weather").addClass("open");
			setTimeout(function(){
				common.resize();
			}, 100);
		});
	},
	showDetail: function(i, t, l){
		let selected = weather.data[i];
		let text = selected.description;
		$("#modal_weather p").html(text);
		
		$(".list_weather_inner ul li").removeClass("active");
		$(".list_weather_inner ul li").eq(i).addClass("active");
		let pos = weather.getPos(i, t, l);
		if(isSmallScreen){
			$("#modal_weather").css({
				"top": t + "px",
				"left": ""
			});
		}else{
			$("#modal_weather").css({
				"top": (t - 30) + "px",
				"left": pos[1] + "px"
			});
		}
		if( !$html.classList.contains("weather_detail") ){
			$html.classList.add("weather_detail");
			$(".bg_modal_weather").off().on("click", function(){
				weather.close();
			});
			$("a.btn_close_modal").off().on("click", function(){
				weather.close();
			});
		}
	},
	close: function(){
		if( $html.classList.contains("weather_detail") ){
			$html.classList.remove("weather_detail");
			$(".list_weather_inner ul li").removeClass("active");
		}
	},
	getPos: function(i,t,l){
		let pos = [0,0];
		let $current = $(".list_weather_inner ul li").eq(i);
		let modalH = $("#modal_weather").outerHeight();
		let endH = modalH + t;
		
		if(l < $(".list_weather_inner ul li").eq(3).position().left){
			//左寄り
			pos = [0, $current.position().left + $current.width()];
		}else{
			pos = [0, $current.position().left - $("#modal_weather").width()];
		}
		return pos;
	}
}